import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Text } from "@mantine/core";
import { AppModal } from "./AppModal";
import { titleCase } from "../utils/String.utils";
export const Confirmation = ({ opened, close, action, additionalText, handleAction, isLoading }) => {
    if (!action || !opened)
        return null;
    const isDestructiveAction = action === "delete" ||
        action === "archive" ||
        action === "decline" ||
        action === "leave" ||
        action === "release";
    return (_jsxs(AppModal, { title: `${titleCase(action)} Confirmation`, opened: opened, onClose: close, closeOnClickOutside: !isLoading, closeOnEscape: !isLoading, children: [_jsx(Text, { variant: "body", children: `Are you sure you want to ${action}?` }), additionalText && _jsx(Text, { variant: "body", children: additionalText }), _jsxs(Flex, { variant: "dialog-actions", gap: "md", children: [_jsx(Button, { variant: "subtle", c: "dimmed", onClick: (event) => {
                            event.stopPropagation();
                            close();
                        }, children: "Cancel" }), _jsx(Button, { variant: "filled", color: isDestructiveAction
                            ? "var(--mantine-color-red-5)"
                            : undefined, loading: isLoading, onClick: async (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            await handleAction();
                            // No need to close here as it is handled by the parent component
                        }, children: `${titleCase(action)}` })] })] }));
};
